import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/styles/global.scss'
import './assets/styles/image-resize.css'
import AudioPlugin from './utils/audio'

// 引入富文本编辑器
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'



Vue.config.productionTip = false

// 配置Element UI
Vue.use(ElementUI, { size: 'medium' })

// 配置富文本编辑器
Vue.use(VueQuillEditor)

// 配置音频插件
Vue.use(AudioPlugin)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
